import { registerMutation, registerQuery, useMutation, useQuery } from 'data-fetching-client';
import apiClient from 'hub-http/clients/apiClient';
// @ts-expect-error dependency missing types
import { catchAndRethrowNetworkError } from 'crm_data/bCommerce/monitoring/errorUtils';
import { useEnrolledProcessor } from './usePaymentsAccountEligibility';
const fetchPaymentsAccountUnderwritingData = () => apiClient.get('payments/v1/payment-accounts/default/underwriting').catch(catchAndRethrowNetworkError);
export const GET_PAYMENTS_ACCOUNTS_UNDERWRITING_DATA = registerQuery({
  fieldName: 'paymentsAccountUnderwriting',
  fetcher: fetchPaymentsAccountUnderwritingData
});
const usePaymentsAccountUnderwritingData = options => {
  const {
    defaultProcessor,
    loading: defaultProcessorLoading
  } = useEnrolledProcessor();
  const {
    data,
    loading,
    error
  } = useQuery(GET_PAYMENTS_ACCOUNTS_UNDERWRITING_DATA, Object.assign({}, options, {
    skip: (options === null || options === void 0 ? void 0 : options.skip) || defaultProcessor !== 'HS_PAYMENTS'
  }));
  return {
    data,
    loading: defaultProcessorLoading || loading,
    error
  };
};
export const updatePaymentsUnderwritingData = data => apiClient.put(`payments/v1/payment-accounts/default/underwriting`, {
  data
});
export const UPDATE_PAYMENTS_ACCOUNTS_UNDERWRITING_DATA = registerMutation({
  fieldName: 'paymentsAccountUnderwriting',
  fetcher: updatePaymentsUnderwritingData
});
export const useUpdatePaymentsAccountUnderwritingData = options => useMutation(UPDATE_PAYMENTS_ACCOUNTS_UNDERWRITING_DATA, options);
export default usePaymentsAccountUnderwritingData;